import { render, staticRenderFns } from "./FilterExtras.vue?vue&type=template&id=041fd84b&"
import script from "./FilterExtras.vue?vue&type=script&lang=js&"
export * from "./FilterExtras.vue?vue&type=script&lang=js&"
import style0 from "./FilterExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports